export default __webpack_public_path__ + "static/media/Shampoo_DEEP_MOIST_250_Q.037f34aa.png";